import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import AppButton from '../../../components/designe/app-button/AppButton';
import { useStyles } from './Others.styles';
import theme from '../../../styles/theme';
import { useAccess } from '../../../hooks/useAccess';
import { useResetCache } from '../../../services/redux/api/appConfigApi';
import { useState } from 'react';

function Others() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const { access } = useAccess();
  const [resetCache, { isLoading }] = useResetCache();
  const [showConfirm, setShowConfirm] = useState(false);

  const canResetCache = access?.cache?.canResetCache ?? false;

  const handleResetCache = () => {
    if (!showConfirm) {
      setShowConfirm(true);
      return;
    }

    resetCache().then((result) => {
      if (!('error' in result)) {
        setShowConfirm(false);
      }
    });
  };

  return (
    <div className={classes.wrapper}>
      <Box>
        {canResetCache && (
          <Box className={classes.buttonWrapper}>
            {!showConfirm ? (
              <AppButton
                onClick={handleResetCache}
                loader={isLoading}
                variant="contained"
                color="primary">
                {t('adminDashboard.resetCache')}
              </AppButton>
            ) : (
              <>
                <AppButton
                  onClick={handleResetCache}
                  loader={isLoading}
                  variant="contained"
                  color="error">
                  {t('adminDashboard.confirmResetCache')}
                </AppButton>
                <AppButton
                  onClick={() => setShowConfirm(false)}
                  variant="outlined"
                  disabled={isLoading}>
                  {t('common.cancel')}
                </AppButton>
              </>
            )}
          </Box>
        )}
      </Box>
    </div>
  );
}

export default Others;
